import React, { createRef, useEffect, useState } from "react";

import "./mobileSinglePieceNavigation.css";

interface MobileSinglePieceNavigationProps {
    active: number;
    setActive: (active: number) => void;
    swipeOffset: number;
}

export default function MobileSinglePieceNavigation(props: MobileSinglePieceNavigationProps) {

    const listRef = createRef<HTMLUListElement>();
    const [activeEl, setActiveEl] = useState<HTMLLIElement>();

    useEffect(() => {
        var currentElement = listRef.current?.querySelector(".active");
        setActiveEl(currentElement as HTMLLIElement);
    }, [props.active, listRef]);
    
        

    return <div className="mobile-single-piece-navigation">
        <hr style={{
            width: activeEl?.offsetWidth + "px",
            left: activeEl?.offsetLeft + "px",
            marginLeft: props.swipeOffset/-4 + "px"
        }}/>
        <ul ref={listRef}>
            <li onClick={() => {
                props.setActive(0);
            }} className={props.active == 0 ? "active" : ""}><h3>Overview</h3></li>
            <li onClick={() => {
                props.setActive(1);
            }} className={props.active == 1 ? "active" : ""}><h3>Involved</h3></li>
            <li onClick={() => {
                props.setActive(2);
            }} className={props.active == 2 ? "active" : ""}><h3>Performances</h3></li>
            <li onClick={() => {
                props.setActive(3);
            }} className={props.active == 3 ? "active" : ""}><h3>Downloads</h3></li>
        </ul>
        </div>;
}